module.exports = __webpack_public_path__ + "static/media/liftoff-with-oreo-on-zerog-hor-en.b6f4b66c.png";